/**
 * Asynchronously loads the component for AttributeList
 */

import { lazyLoad } from 'utils/loadable';

export const AttributeList = lazyLoad(
  () => import('./index'),
  module => module.AttributeList
);
